import { z } from "zod";

export const MenuItemIconKeySchema = z.enum([
  "accounts",
  "business-units",
  "employees",
  "subscriptions",
  "hardware",
  "delivery",
  "quotes",
  "orders",
  "invoices",
  "payment-methods",
  "service-appoyntment",
  "add-new",
  "support-center",
  "knowledge-base",
  "university",
  "faq",
  "support",
  "log-out",
  "user-edit",
]);

export const MenuItemTagSchema = z.enum(["footer", "user", "header", "guest"]);

export const MenuChildrenItemSchema = z.object({
  id: z.string(),
  text: z.string().optional(),
  iconKey: MenuItemIconKeySchema.optional(),
  href: z.string().optional(),
  target: z.string().optional(),
  tags: MenuItemTagSchema.array(),
});

export const MenuItemSchema = MenuChildrenItemSchema.extend({
  tags: MenuChildrenItemSchema.shape.tags.optional(),
  children: MenuChildrenItemSchema.array().optional(),
});

export type MenuItemType = z.infer<typeof MenuItemSchema>;
export type MenuItemTagType = z.infer<typeof MenuItemTagSchema>;
export type MenuItemIconKeyType = z.infer<typeof MenuItemIconKeySchema>;
export type MenuChildrenItemType = z.infer<typeof MenuChildrenItemSchema>;
